<template>
  <div class="guess-container">
    <van-popup v-model="guessInfoShow" position="bottom" round :overlay="false" :close-on-click-overlay="false" style="border-radius: 5px 5px 0 0;">
      <template #default>
        <div class="guess-container-p">
          <div class="title">{{ guessTitle }}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="clear" color="#FFF" size="0.3rem" /></div>
          <div class="guess-content-p">
            <div v-for="(item, index) in guessList" :key="index" class="guess-item">
              <div v-for="(item1, index1) in item.title.split(';')" :key="index1" class="guess-item-title">{{ item1 }}</div>
              <div v-if="item.type == 'radio'">
                <van-radio-group v-model="guessList[index].answer">
                  <van-radio v-for="(item1, index1) in item.aname" :key="index1" :name="item1">{{ item1 }}</van-radio>
                </van-radio-group>
              </div>

              <!--冯，2024-04-24 添加多选-->
              <div v-if="item.type == 'check'">
                <van-checkbox-group v-model="guessList[index].answer">
                  <van-checkbox style="margin-bottom: 3px" v-for="(item1, index1) in item.aname" :key="index1" :name="item1" shape="square">
                    <span style="color: #ffffff!important;">{{ item1 }}</span>
                  </van-checkbox>
                </van-checkbox-group>
              </div>

            </div>
          </div>
          <van-button type="info" round class="guessBtn" color="#00BDFF" :disabled="!validForm" @click="submit">{{ content.submitQuick }}</van-button>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
import { postAddQuestionAnswer } from '@/models/common'
export default {
  props: {
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    },
    liveMettingId: {
      type: [String, Number, null],
      default: null
    },
    liveStreamId: {
      type: [String, Number],
      default: ''
    },
    memberId: {
      type: String,
      default: ''
    }
  },
  computed: {
    validForm: function() {
      let arr = this.guessList.filter((item) => item.answer == '')
      if (arr.length == 0) {
        return true
      } else {
        return false
      }
    },
    isAllRight() {
      let flag = true
      for(let i = 0; i < this.guessList.length; i++) {
        let ele = this.guessList[i]
        if(ele.type == 'radio') {
          if(ele.answer == ''){
            flag = false
            break
          } else if(ele.result.includes(ele.answer)){
            // 当前答案正确，继续判断下一题
          } else {
            flag = false
            break
          }
        }
        //  冯添加多选，2024-04-24
        else if(ele.type == 'check'){
          if(ele.answer == []){
            flag = false
            break
          }
          // else if(ele.result.includes(ele.answer)){
          else if(this.getInclude(ele.result,ele.answer)){
            // 当前答案正确，继续判断下一题
          } else {
            flag = false
            break
          }
        }
      }
      return flag ? 1 : 0
    },
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    }
  },
  data() {
    return {
      guessInfoShow: false, // 完善弹框
      guessTitle: '', // 弹框标题
      guessId: '', // 本次问答Id
      guessList: [] // 本次问答内容
    }
  },
  methods: {
    //判断一组数组中是否包含另一组数组
    getInclude(superset, subset) {
      return subset.every(item => superset.includes(item));
    },
    // 关闭弹窗
    closeDialog() {
      this.guessInfoShow = false
    },
    // 完善资料弹窗
    showDialog(data) {
      this.guessTitle = data.title
      this.guessId = data.id
      this.guessList = data.answers.map((item) => {
        return {
          ...item,
          // answer: ''
          answer: data.type == 'radio' ? '' : []
        }
      })
      this.guessInfoShow = true
    },
    // 提交
    submit() {
      let name = this.guessList.map(item => item.answer)
      postAddQuestionAnswer({
        live_metting_id: this.liveMettingId,
        live_stream_id: this.liveStreamId,
        member_id: this.memberId,
        question: this.guessTitle,
        answer: JSON.stringify(name),
        question_id: this.guessId,
        is_all_right: this.isAllRight
      }).then((res) => {
        if (res.data.code == 0) {
          this.$toast(this.content.submitSuccess)
          this.closeDialog()
        } else {
          this.$toast(res.data.message)
          this.closeDialog()
        }
      })
    },
    // 重置
    resetForm() {
      this.guessTitle = ''
      this.guessId = ''
      this.guessList = []
    }
  }
}
</script>

<style lang="less" scoped>

.guess-container {
  /deep/.van-popup {
    background-color: rgba(0, 0, 0, 0.8);
  }
  .guess-container-p {
    padding: 0 0.35rem;
    .title {
      font-size: 0.23rem;
      color: #f39605;
      font-weight: bold;
      text-align: left;
      margin-top: 0.2rem;
      margin-bottom: 0.1rem;
    }
    .close-icon {
      position: absolute;
      top: 0.2rem;
      right: 0.3rem;
      cursor: pointer;
      //   background-color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
    }
    .guess-content-p {
      max-height: 70vh;
      overflow-y: auto;
      .guess-item {
        color: #fff;
        font-size: 0.2rem;
        .guess-item-title {
          line-height: 1.8;
        }
        /deep/.van-radio {
          padding: 0.1rem 0;
        }
        /deep/.van-radio__label {
          color: #fff;
          font-size: 0.2rem;
        }
      }
    }
    .guessBtn {
      width: 2.8rem;
      height: 0.5rem;
      margin: 0.1rem auto 0.2rem;
      display: block;
    }
  }
}
</style>
